import { eventNames, useCoreEvents } from '@carvana/core-events';
import { useContext, useEffect, useRef } from 'react';
import { SebastianStatus } from '~/constants/common/SebastianStatus';
import SebastianContext from '~/context/common/SebastianContext';

// The name the ChatUI MFE reports in mfer.events payloads — no typed constant exists in eventNames.
const CHAT_UI_EVENT = 'header-chat-ui';

export default function useSebastianLoaded() {
  const { setSebastianStatus } = useContext(SebastianContext);
  const pendingTimeouts = useRef(new Set<number>());

  useCoreEvents(eventNames.chatUi.ready, () => {
    // Wait a tick before updating the status. The stack trace is unclear on
    // where the issue lies, but it may be in the microfrontend package or
    // perhaps the ChatUI MFE. In any case, without this, an error appears in
    // the browser console:
    //
    // Warning: Cannot update a component (`SebastianContextProvider`) while
    // rendering a different component (`rg`).
    const id = window.setTimeout(() => {
      setSebastianStatus(SebastianStatus.Ready);
      pendingTimeouts.current.delete(id);
    }, 0);
    pendingTimeouts.current.add(id);
  });

  useCoreEvents(eventNames.mfer.events, event => {
    if (event.name === CHAT_UI_EVENT && event.error) {
      setSebastianStatus(SebastianStatus.Error);
    }
  });

  useEffect(() => {
    const timeouts = pendingTimeouts.current;

    return () => {
      timeouts.forEach(clearTimeout);
      timeouts.clear();
    };
  }, []);
}
